import './portfolio-mockup.scss';
import { PortfolioDetailData } from '@/data/portfolio/portfolio-detail-data';
import PortfolioMockupItem from './portfolio-mockup/portfolio-mockup-item';
import { motion, useInView } from 'motion/react';
import { useRef } from 'react';

type Props = {
	mockup: PortfolioDetailData['mockup'];
};

const PortfolioMockup = ({ mockup }: Props) => {
	if (!mockup) return null; // 목업이 없는 경우 렌더링 하지 않음
	const { mockupImage, mockupVideo } = mockup;
	const ref = useRef<HTMLDivElement>(null);
	const inView = useInView(ref, { once: true, margin: '0px 0px -100px 0px' });

	return (
		<>
			<div ref={ref} />
			<motion.div
				initial={{ opacity: 0, y: 100 }}
				animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 100 }}
				transition={{ duration: 0.8, ease: 'easeOut', delay: 0.4 }}
			>
				<div className="portfolio-mockup-wrapper">
					<section className="phone-mockup-item-box image-box">
						<PortfolioMockupItem>
							<img src={mockupImage} className="phone-img" />
						</PortfolioMockupItem>
					</section>
					<section className="phone-mockup-item-box video-box">
						<PortfolioMockupItem>
							<div className="phone-video-wrapper">
								<video
									src={mockupVideo}
									autoPlay
									muted
									loop
									playsInline
									placeholder={mockupImage}
								/>
							</div>
						</PortfolioMockupItem>
					</section>
				</div>
			</motion.div>
		</>
	);
};

export default PortfolioMockup;
